import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { MFormation } from '@argalis-apps/models';
import { CatalogConfigService } from '../../services/catalog-config/catalog-config.service';

@Component({
  selector: 'ags-formation-overview-card',
  templateUrl: './formation-overview-card.component.html',
  styleUrls: ['./formation-overview-card.component.scss']
})
export class FormationOverviewCardComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @Input() public formation: MFormation.IFormOverview;

  constructor(private router: Router, private catalogConfigService: CatalogConfigService) {
    this.themeFlag = `${this.themeFlag || ''} ${catalogConfigService.themingClassName}`;
  }

  ngOnInit() {}

  getModalityIcon(modalite) {
    switch (modalite) {
      case 1:
        return 'k-i-user';
      case 2:
        return 'k-i-cloud';
      case 3:
        return 'k-i-html';
      default:
        break;
    }
    return '';
  }

  clickCard() {
    this.router.navigate(['/', this.catalogConfigService.routingBaseUri, 'formation', this.formation.id]);
  }
}
